import { getCommonParamsItemLabel } from '@/utils/common.js'
export const contentTableConfig = {
  propList: [
    {
      prop: 'userName',
      label: 'common.app-merchant-name',
      width: 160
    },
    {
      prop: 'name',
      label: 'user.name',
      width: 160
    },
    {
      prop: 'tenantName',
      label: 'file.tenant',
      width: 160
    },
    {
      prop: 'email',
      label: 'user.email',
      width: 200
    },
    {
      prop: 'mobile',
      label: 'user.phone',
      width: 150
    },
    {
      prop: 'status',
      label: 'general.status',
      width: 100,
      formatter: (row) => {
        return getCommonParamsItemLabel(row, 'status')
      }
    },
    {
      prop: 'createdTime',
      slotName: 'formatZeroTime',
      width: 160,
      label: 'common.app-creation-time'
    },
    {
      label: 'customer.customer-operation',
      width: 380,
      slotName: 'handler'
    }
  ],
  showIndexColumn: true
}
